import { GenericForm } from "../../components/generic-form/GenericForm.types";
import { GenericFormValidator } from "../../components/generic-form/utility/GenericFormValidator";
import { IBasket } from "../../entities/IBasket";

export const createBasketForm: GenericForm<CreateBasketDTO> = {
  name: {
    type: "input",
    name: "name",
    label: "TABLE.TITLE",
    defaultValue: "",
    validators: [
      GenericFormValidator.required(),
      GenericFormValidator.minChar({
        limit: 3,
      }),
      GenericFormValidator.maxChar({
        limit: 128,
      }),
    ],
  },
  processDescription: {
    type: "richTextInput",
    name: "processDescription",
    label: "TABLE.DESCRIPTION",
    defaultValue: "",
  },
};

export const updateBasketForm: GenericForm<UpdateBasketDTO> = {
  name: {
    type: "input",
    name: "name",
    label: "TABLE.TITLE",
    defaultValue: "",
    validators: [
      GenericFormValidator.required(),
      GenericFormValidator.minChar({
        limit: 3,
      }),
      GenericFormValidator.maxChar({
        limit: 128,
      }),
    ],
  },
  processDescription: {
    type: "richTextInput",
    name: "processDescription",
    label: "TABLE.DESCRIPTION",
    defaultValue: "",
  },
  id: {
    type: "hidden",
    visibleIf: () => false,
    name: "id",
    label: "id",
    defaultValue: 0,
    validators: [],
  },
};

export interface CreateBasketDTO {
  name: string;
  processDescription?: string;
}

export interface CreateBasketModalProps {
  onDismiss: () => void;
  onSubmit: (data: CreateBasketDTO) => void;
  creating: boolean;
  isVisible: boolean;
  createBasketForm: GenericForm<CreateBasketDTO>;
}

export interface UpdateBasketModalProps {
  onDismiss: () => void;
  onSubmit: (data: UpdateBasketDTO) => void;
  updating: boolean;
  isVisible: boolean;
  updateBasketForm: GenericForm<UpdateBasketDTO>;
}

export interface BasketCardInfoProps {
  name: string;
  numberOfTasks: number;
}
export interface BasketCardActionProps {
  id: number;
  isBookmarked: boolean;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onBookmark: (id: number) => void;
  onClick: () => void;
}

export type BasketCardProps = BasketCardInfoProps & BasketCardActionProps;

export interface IGetBasket {
  id: number;
  name: string;
  isBookmarked: boolean;
  numberOfTasks: number;
  processDescription?: string;
  documentTypeCodesForBasketRules: string[];
}

export interface BasketSectionProps {
  baskets: IGetBasket[];
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onBookmark: (id: number) => void;
}

export type AllBasketSectionProps = BasketSectionProps;

export type UpdateBasketDTO = IBasket;

export interface IGetBasketApi {
  baskets: IGetBasket[];
  count: number;
}

export interface BasketCardInfoProps {
  name: string;
  numberOfTasks: number;
}
export interface BasketCardActionProps {
  id: number;
  isBookmarked: boolean;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onBookmark: (id: number) => void;
  onClick: () => void;
}

export interface BasketSectionProps {
  baskets: {
    id: number;
    name: string;
    isBookmarked: boolean;
    numberOfTasks: number;
    processDescription?: string;
    documentTypeCodesForBasketRules: string[];
  }[];
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onBookmark: (id: number) => void;
}

export interface DeleteBasketModalProps {
  isVisible: boolean;
  onDismiss: () => void;
  onDelete: () => void;
  deleting: boolean;
}
